// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "OrderView" + "." + "8ac1ff16" + ".js";
};